import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Grid, Button, Table, Card, Box, TableHead, TableRow, TableBody, TableCell, TableContainer, useTheme } from '@mui/material'
import { useMessage } from "../../context/message-context";
import { pad, setColor2, setColor3, setGradient2 } from "../../functions/default";
import { DateTextField } from "../lib";
import Modulgruppenfilter from '../Modulgruppenfilter/Modulgruppenfilter';
function Tageskalender(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { client, accessToken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { showErrorMessage } = useMessage();
  const [fehltag, setFehltag] = useState([])
  const [sdat, setSdat] = useState(new Date(new Date().getTime()).getFullYear().toString() + '-' + pad(new Date(new Date().getTime()).getMonth() + 1, 2) + '-' + pad(new Date(new Date().getTime()).getDate(), 2));
  const [tage, setTage] = useState(7)
  const [zr, setZr] = useState("")
  const [gruppen, setGruppen] = useState([])
  const [magruppen, setMagruppen] = useState([])
  const [gruppe, setGruppe] = useState(0)
  const [untergeben, setUntergeben] = useState(0)
  const [filteraktiv, setFilteraktiv] = useState("")
  const [datumGrenze] = useState(new Date(new Date().setDate(new Date().getDate() - 1095)));
  const [datumGrenzeFormat] = useState(datumGrenze.getFullYear().toString() + '-' + pad(datumGrenze.getMonth() + 1, 2) + '-' + pad(datumGrenze.getDate(), 2));

  useEffect(() => {
    if (sdat === "") {
      return
    }
    if (sdat < datumGrenzeFormat) {
      setSdat(datumGrenzeFormat)

    }

    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": (location.pathname === "/PMABW2") ? "PMABW2": (location.pathname === "/PMABW3") ? "PMABW3" : "PMABWU",
      "statement": "TAGESKALENDER",
      "sdat": sdat > datumGrenzeFormat ? sdat : datumGrenzeFormat,
      "tage": tage,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postUebersicht);
    // eslint-disable-next-line
  }, [sdat, tage])
  const postUebersicht = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setFehltag(response.data.fehltag)
      setZr(response.data.zr)
      if (response.data.filter) {
        setFilteraktiv(response.data.filter);
      }
      if (response.data.gruppen) {
        setGruppen(response.data.gruppen);
      }
      if (response.data.magruppen) {
        setMagruppen(response.data.magruppen);
      }
      console.log(response.data.fehltag)
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      navigate(-1);
    }
  }

  const getButtonStyle = (color, antrag) => {
    if (antrag && antrag === "J") {
      return {
         color: setColor2("000000000", 1), 
         background: setGradient2(color)
      }
    } else {
      return {
        color: setColor2("000000000", 1), 
        backgroundColor: setColor2(color, "1")
     }
    }
  }

  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <Box p={2}>
      <Grid container justifyContent="center" spacing={2}>
        {(filteraktiv === "J") &&
          <Grid item xs={12} md={6} lg={6}>
            <Box p={1}>
              <Card>
                <Box p={1}>
                  <Modulgruppenfilter
                    gruppen={gruppen}
                    onMitarbeiterChange={setUntergeben}
                    onGruppeChange={setGruppe}
                    small={true}
                    //notitle={true}
                    mitarbeiter={magruppen}
                    kz="full"
                  />
                </Box>
              </Card>
            </Box>
          </Grid>
        }
        <Grid item xs={12}>
          <Card>
            <Box p={2}>
              <Grid container justifyContent="center" spacing={0}>
                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <DateTextField
                        value={sdat}
                        variant="outlined"
                        onChange={(e) => { setTage(7); setSdat(e.target.value) }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>{t("Zeitraum")}</TableCell>
                              <TableCell>{zr}</TableCell>
                            </TableRow>
                          </TableHead>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </Grid>

                {fehltag && fehltag.length > 0 && fehltag.map((item, index) => {
                  return (
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>
                                {item.anzeige}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item.eintrag && item.eintrag.length > 0 && item.eintrag.filter((item3, index3) => {
                              if (item3.own === "J") return true
                              if (untergeben && untergeben !== "A" && item3.untergeben.includes(untergeben) === false) { return false }
                              if (gruppe && gruppe !== "A" && item3.gruppe.includes(gruppe) === false) { return false }
                              return true
                            }).map((item2, index2) => {
                              return (
                                <TableRow>
                                  <TableCell>
                                    {item2.name}
                                  </TableCell>
                                  <TableCell style={getButtonStyle(item2.color, item2.antrag)}>
                                    <span style={item2.antrag && item2.antrag === "J" &&{
                                      padding: "4px 2px",
                                      backgroundColor: theme.palette.background.default,
                                      color: theme.palette.text.primary
                                    }}>
                                      {item2.fz}
                                    </span>
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  )
                })}
                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Button
                        disabled={tage >= 28}
                        color="primary"
                        variant="outlined"
                        onClick={() => { setTage(tage + 7) }}
                      >{t("Mehr Tage laden")}</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
export default Tageskalender;
